import React from 'react';
import { TOMOS } from '../../data/content';
export function WhatsIncluded() {
  return <section className="bg-crema-alt py-16 sm:py-20 px-5" data-id="element-300" data-mp="35j53woz5jsj0">
      <div className="max-w-6xl mx-auto" data-id="element-301" data-mp="35gsfpu2swlxi">
        <div className="text-center max-w-3xl mx-auto" data-id="element-302" data-mp="30j9471xhmn99">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-violeta leading-tight" data-id="element-303" data-mp="30hpmd6w6o45d">
            Los 6 tomos, en el orden en que hay que hacerlos
          </h2>
          <p className="mt-4 text-lg text-tinta/75" data-id="element-304" data-mp="3t74yjzzl432v">
            Cada tomo apoya sobre el anterior. No hace falta que elijas por dónde empezar.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-305" data-mp="3j9qpilfzqgkl">
          {TOMOS.map((tomo, i) => {
          const destacado = i === TOMOS.length - 1;
          return <article key={tomo.titulo} className={`relative rounded-2xl bg-white p-6 shadow-sm flex flex-col ${destacado ? 'border-2 border-dorado pt-9' : 'border border-black/5'}`} data-id="element-306" data-mp="27uv66m6efqxp" data-mpi={i}>
                {destacado && <span className="absolute -top-3 left-6 bg-dorado text-white text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-307" data-mp="2mtocwpbk44ck">
                    Esto no lo tiene ningún otro kit
                  </span>}
                <span className={`w-11 h-11 rounded-full flex items-center justify-center font-serif text-xl font-bold ${destacado ? 'bg-dorado text-white' : 'bg-violeta text-crema'}`} aria-hidden="true" data-id="element-308" data-mp="2cte1na931701">
                  {i + 1}
                </span>
                <h3 className="mt-4 font-serif text-xl font-bold text-violeta" data-id="element-309" data-mp="1u47m1w3l4vig">
                  <span className="sr-only" data-id="element-310" data-mp="1u24rcyrhme7e">Tomo {i + 1}: </span>
                  {tomo.titulo}
                </h3>
                <p className="mt-2 text-base leading-snug text-tinta/80" data-id="element-311" data-mp="1l3j8t3m0mz6m">{tomo.descripcion}</p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}